import Dialog from '@material-ui/core/Dialog';
import { useMediaQuery } from 'common/utils';
import { useInfiniteQuery } from 'react-query';
import InfiniteScroll from 'components/common/InfiniteScroll';
import styles from './TippedListDialog.module.scss';
import { getTippedOfPost } from 'service/payment';
import useGlobalStore from 'store/global';
import { TippedInfoDetail, User } from 'common/interfaces/api';
import { useMemo } from 'react';
import Icon from 'components/common/Icon';
import TippedItem from 'components/common/TippedItem';
import useStore from 'store/timeline';
import { useEffect } from 'react';
import classNames from 'classnames';
import LinkButton from 'components/common/LinkButton';
import { UserWithDeletedCheck } from '../UserInfo';

export default function TippedListDialog({
  open,
  setOpen,
  postId,
  isLiveCreator = false,
  handleChooseUser,
}: {
  open: boolean;
  setOpen: (open: boolean) => void;
  postId: number;
  isLiveCreator?: boolean;
  handleChooseUser?: (user: User) => void;
}): JSX.Element {
  const isMobile = useMediaQuery('(max-width: 767px)');
  const shouldRefetchTippedListOfPost = useStore(
    (state) => state.shouldRefetchTippedListOfPost
  );
  const isAuthInit = useGlobalStore((state) => state.isAuthInit);
  const { refetch, data, fetchNextPage, isFetchingNextPage } = useInfiniteQuery(
    ['getTippedListDialogOfPost', postId?.toString()],
    async ({ pageParam = 1 }) => {
      if (!open || !postId || !isAuthInit) return Promise.reject();
      return await getTippedOfPost(postId, pageParam);
    },
    {
      getNextPageParam: (lastPage, pages) => {
        const list = lastPage?.data?.tipped_users;
        if (list && list.length > 0) {
          return pages.length + 1;
        }
      },
      enabled: isAuthInit && open,
      refetchOnWindowFocus: false,
    }
  );
  useEffect(() => {
    if (shouldRefetchTippedListOfPost) {
      void refetch();
    }
  }, [shouldRefetchTippedListOfPost, refetch]);

  const pages = data?.pages;
  const tippedInfos: TippedInfoDetail[] = useMemo(
    () =>
      pages
        ? pages.reduce<TippedInfoDetail[]>((curr, page) => {
            const infos = page.data?.tipped_users || [];
            return curr.concat(infos);
          }, [])
        : [],
    [pages]
  );
  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
      maxWidth="lg"
      fullScreen={isMobile}
      scroll="body"
      PaperProps={{
        style: {
          backgroundColor: 'transparent',
          boxShadow: 'none',
          padding: isMobile ? '5vh 0 5vh 0' : '',
        },
      }}
    >
      <div className={styles.dialogWrapper}>
        <div className={styles.header}>
          <div className={styles.title}>購入されたありがとう</div>
          <div className={styles.closeBtn}>
            <Icon
              name="close-black"
              width={16}
              height={16}
              onClick={() => setOpen(false)}
            />
          </div>
        </div>
        <InfiniteScroll
          fetchNextPage={fetchNextPage}
          isLoading={isFetchingNextPage}
        >
          <div
            className={classNames(styles.container, {
              [styles.isLiveCreator]: isLiveCreator,
            })}
          >
            {tippedInfos.map((info, index) => {
              return (
                <div
                  key={`post-${postId}-info-${index}`}
                  className={styles.tippedItem}
                >
                  <UserWithDeletedCheck user={info.user} />
                  <div className={styles.tippedInfo}>
                    <TippedItem
                      tippedInfo={info}
                      className={styles.tippedLabel}
                    />
                    {isLiveCreator && (
                      <div>
                        <LinkButton
                          text="コメントを見る"
                          onClick={() => {
                            handleChooseUser && handleChooseUser(info.user);
                            setOpen(false);
                          }}
                        />
                      </div>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </InfiniteScroll>
      </div>
    </Dialog>
  );
}
